import * as React from 'react';

import { useLocation } from 'js/lib/useRouter';

import { useCoachEpicEnabledState } from 'bundles/ai-course-coach/utils/productFeatureFlags';
import Help from 'bundles/common/components/Help';
import { isCareerAcademyPage } from 'bundles/unified-common/utils/orgScopedRouteUtils';

type Props = {
  children: React.ReactNode;
};

export const EnterpriseOrgScopedPageExtras = ({ children }: Props) => {
  const { pathname } = useLocation();

  const { showEmbeddedCoach } = useCoachEpicEnabledState();
  const isCoachEnabled = showEmbeddedCoach;

  const renderHelpButton = !isCoachEnabled && !isCareerAcademyPage(pathname);

  return (
    <React.Fragment>
      <main>{children}</main>
      {renderHelpButton && <Help style={{ minWidth: 0, bottom: 12, right: 12 }} isEnterprise />}
    </React.Fragment>
  );
};
